enum EWizardSteps {
  'PERSONAL_INFORMATION' = 'personal-information',
  'CHOOSE_CONTACT' = 'choose-contact',
  'CONFIRMATION' = 'confirmation',
}

export default EWizardSteps;
